import { connect } from 'react-redux';
import { SidewayNavigation } from '@web/vitafy-react-components';

const Navigation = props => {
    const match = {
        exact: 'EXACT',
        partial: 'PARTIAL',
        mismatch: 'MISMATCH',
        error: 'ERROR'
    };

    const { categories, categoryPath, q, className } = props;


    // [int] -> [int] -> String
    const comparePaths = (xs, ps) => {
        for (var i = 0; i < xs.length; i++) {
            if (xs[i] !== ps[i]) {
                return match.mismatch;
            }
        }
        if (xs.length === ps.length) {
            return match.exact;
        } else if (ps.length < xs.length) {
            return match.error;
        } else {
            return match.partial;
        }
    };

    const findSiblings = (cs, path) => {
        for (var i = 0; i < cs.length; i++) {
            switch (comparePaths(cs[i].path, path)) {
                case match.exact :
                    return cs;
                case match.partial:
                    // "Category" brand has no children
                    return cs[i].children ? findSiblings(cs[i].children, path) : [];
                case match.error:
                    return [];
            }
        }

        return [];
    };

    try {
        const {title, siblings} =
            findSiblings(categories, categoryPath)
                ?.reduce(
                    (acc, x) => {
                        x.path[x.path.length - 1] === categoryPath[categoryPath.length - 1] ?
                            acc.title = x.name
                            : acc.siblings.push({name: x.name, href: '/' + x.url});

                        return acc;
                    },
                    {title: '', siblings: []}
                );

        return <div id="sideway-navigation" style={{display: 'none', margin: '0 0 -0.75rem'}}><SidewayNavigation  {...{title, siblings}} /></div>;
    } catch (e) {
        console.error(e);
        return <></>;
    }
};

export default connect(({ categories, categoryPath, hits, q }) => ({ categories, categoryPath, hits, q }))(Navigation);
